import React, { useState, useMemo } from 'react';
import CalcShell, { StepsPanel } from '../CalcShell';

export default function CircleCalc() {
  const [given, setGiven] = useState('radius');
  const [value, setValue] = useState(5);
  const c = useMemo(() => {
    let r;
    if (given === 'radius') r = value;
    else if (given === 'diameter') r = value/2;
    else if (given === 'circumference') r = value/(2*Math.PI);
    else r = Math.sqrt(value/Math.PI);
    return { radius: r, diameter: 2*r, circumference: 2*Math.PI*r, area: Math.PI*r*r };
  }, [given, value]);
  return (
    <CalcShell look="cnet" title="Circle Calculator" subtitle="Given any one of radius, diameter, circumference or area, compute all others.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Given</label>
            <select value={given} onChange={e => setGiven(e.target.value)}>
              <option value="radius">Radius</option><option value="diameter">Diameter</option>
              <option value="circumference">Circumference</option><option value="area">Area</option>
            </select>
          </div>
          <div className="field"><label>Value</label><input type="number" step="any" value={value} onChange={e => setValue(+e.target.value || 0)} /></div>
          <table className="data-table"><tbody>
            <tr><td>Radius (r)</td><td className="text-right">{c.radius.toFixed(4)}</td></tr>
            <tr><td>Diameter (d)</td><td className="text-right">{c.diameter.toFixed(4)}</td></tr>
            <tr><td>Circumference (C)</td><td className="text-right">{c.circumference.toFixed(4)}</td></tr>
            <tr><td>Area (A)</td><td className="text-right font-semibold">{c.area.toFixed(4)}</td></tr>
          </tbody></table>
        </div>
        <div className="bg-slate-50 rounded-2xl p-6 flex items-center justify-center">
          <svg viewBox="0 0 200 200" className="w-full max-w-xs">
            <circle cx="100" cy="100" r="75" fill="#ede9fe" stroke="#7c3aed" strokeWidth="2" />
            <line x1="100" y1="100" x2="175" y2="100" stroke="#7c3aed" strokeDasharray="4" />
            <circle cx="100" cy="100" r="3" fill="#7c3aed" />
            <text x="115" y="95" fontSize="12">r</text>
          </svg>
        </div>
      </div>
      <StepsPanel steps={[`d = 2r`, `C = 2πr`, `A = πr²`]} />
    </CalcShell>
  );
}
